import { render } from "./VabeneSupplementTypeList.vue?vue&type=template&id=6efe4c9b&ts=true"
import script from "./VabeneSupplementTypeList.vue?vue&type=script&lang=ts"
export * from "./VabeneSupplementTypeList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__